// extracted by mini-css-extract-plugin
module.exports = {"form":"forgot-password_form__1J6oJ","inputContainerGroup":"forgot-password_inputContainerGroup__105GG","logoContainer":"forgot-password_logoContainer___0wuK"};